import UserInfoActions from '../../actions/UserInfoActions';
import AppConstants from '../../constants/AppConstants';
import store from '../../stores/redux';
import { initialState } from '../../reducer/serverStorage';
import helper from './helper';

const { dispatch } = store;
const actions = {
    saveStateServerStorage(store) {
        dispatch({
            type  : AppConstants.SERVER_STORAGE_SUCCESS,
            items : store
        });
    },

    saveServerStorage(key, data) {
        const storeServerStorage = store.getState().serverStorage.store;
        let newStoreServerStorage = {
            ...storeServerStorage,
            dataTable: {
                ...storeServerStorage.dataTable,
                [key]: helper.dateDelete(data),
                version: initialState.store.dataTable.version
            }
        };

        actions.saveStateServerStorage(newStoreServerStorage);
        UserInfoActions.setServerStorage();
    },
};

export default actions;
